import React from 'react';
import { Helmet } from 'react-helmet-async';
import PageTitle from 'components/PageTitle';
import ListGroup from 'react-bootstrap/ListGroup';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import { LeagueName } from '../../consts';

const MetaTitle = `Kontakt - ${LeagueName}`;

const Contact: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>{MetaTitle}</title>
        <meta property="og:title" content={MetaTitle} />
        <meta name="twitter:title" content={MetaTitle} />
      </Helmet>
      <section>
        <PageTitle>Kontakt</PageTitle>
        <Container className="pt-5 pb-5">
          <Row className="justify-content-center">
            <Col xs={12} lg={6}>
              <ListGroup variant="flush">
                <ListGroup.Item
                  action
                  href="mailto:contact@reclimb.com"
                  className="text-center"
                >
                  liga@reclimb.com
                </ListGroup.Item>
                <ListGroup.Item
                  action
                  href="tel:+48693866171"
                  className="text-center"
                >
                  693-866-171
                </ListGroup.Item>
              </ListGroup>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Contact;
